import { BasicComponent } from "haxt";

import "./DataPage.scss";
import { Hero } from "../components/sections/Hero";
import { CardSection } from "../components/sections/CardSection";
import { CardMedia } from "../components/cards/CardMedia";
import { CardItem } from "../components/cards/CardItem";
import { Section } from "./data/data-types";
import { CardImage } from "../components/cards/CardImage";
import { GridGallery } from "../components/sections/GridGallery";

export class DataPage extends BasicComponent<{
	page: string;
	parts: string[];
	data: {
		sections: (Section | (() => JSX.Element))[];
	}
}> {
	public render() {
		let data = this.props.data;
		return (
			<div class="DataPage">
				{data.sections.map((section) => {
					if (typeof section === "function") {
						return section();
					} else if (section.type === "hero") {
						return <Hero options={section.options} data={section.data} />;
					} else if (section.type === "cards") {
						return (
							<CardSection options={section.options}>
								{section.items.map((item) => {
									if (item.type === "CardMedia") {
										return <CardMedia options={item.options} data={item.data} />;
									} else if (item.type === "CardItem") {
										return <CardItem options={item.options} data={item.data} />;
									} else if (item.type === "CardImage") {
										return <CardImage options={item.options} data={item.data} />;
									} else {
										return null;
									}
								})}
							</CardSection>
						);
					} else if (section.type === "grid-gallery") {
						return (
							<GridGallery options={section.options} items={section.items} />
						);
					} else {
						return null;
					}
				})}
			</div>
		);
	}
}
